<template>
  <div>
    <vx-card v-if="templates.length" class="content-blocks">
      <div class="mb-6">
        <h5>Контентные блоки</h5>
      </div>
      <draggable
        animation="200"
        ghostClass="ghost"
        tag="ul"
        class="templates-list"
        :list="templates"
        :disabled="!isDraggable"
        :class="{'templates-list--disabled': !isDraggable}"
        @change="changeOrder"
      >
        <li class="templates-list__item" :key="template.id" v-for="template in templates">
          <div class="flex items-start">
            <vs-icon
              class="icon-draggable"
              type="flat"
              icon-pack="feather"
              icon="icon-menu"
              disabled
            />
            <div class="w-full">
              <TextTemplate
                v-if="template.message_type === 'text'"
                :template="template"
                @save="saveTemplate"
                @delete="deleteTemplate"
              />

              <ImageTemplate
                v-if="template.message_type === 'image'"
                :template="template"
                @save="saveTemplate"
                @delete="deleteTemplate"
              />

              <FileTemplate
                v-if="template.message_type === 'file'"
                :template="template"
                @save="saveTemplate"
                @delete="deleteTemplate"
              />

              <LocationTemplate
                v-if="template.message_type === 'location'"
                :template="template"
                @save="saveTemplate"
                @delete="deleteTemplate"
              />
            </div>
          </div>
        </li>
      </draggable>
    </vx-card>

    <div class="buttons-in-popup">
      <div class="flex">
        <vs-button
          type="flat"
          size="large"
          icon-pack="feather"
          icon="icon-align-left"
          @click.prevent="addNewTemplate('text')"
        />
        <vs-button
          type="flat"
          size="large"
          icon-pack="feather"
          icon="icon-image"
          @click.prevent="addNewTemplate('image')"
        />
        <vs-button
          type="flat"
          size="large"
          icon-pack="feather"
          icon="icon-file"
          @click.prevent="addNewTemplate('file')"
        />
        <vs-button
          type="flat"
          size="large"
          icon-pack="feather"
          icon="icon-map-pin"
          @click.prevent="addNewTemplate('location')"
        />
      </div>
    </div>
  </div>
</template>

<script>

import TextTemplate from './templates/TextTemplate'
import ImageTemplate from './templates/ImageTemplate'
import FileTemplate from './templates/FileTemplate'
import LocationTemplate from './templates/LocationTemplate'

import draggable from 'vuedraggable'

import MessageTemplates from '../../../api/http/models/MessageTemplates'

export default {
  props: {
    companySlug: {
      type: String,
      required: true
    },
    scenarioSlug: {
      type: String,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      templates: []
    }
  },
  components: {
    TextTemplate,
    ImageTemplate,
    LocationTemplate,
    FileTemplate,
    draggable
  },
  computed: {
    isDraggable () {
      return (
        !this.templates.find(template => template.new)
      )
    }
  },
  async created () {
    const response = await MessageTemplates.getAll(this.companySlug, this.scenarioSlug, this.stepId)

    if (response.data) {
      this.templates = response.data.sort((a, b) => a.order - b.order)
    }

    this.$emit('loaded')
  },
  methods: {
    async addNewTemplate (type) {
      const block = {
        id: (new Date()).getTime(),
        new: true,
        message_type: type,
        body: '',
        additional_data: {
          'location.latitude': '',
          'location.longitude': '',
          'location.address': '',
          'image.key': '',
          'file.key': ''
        }
      }

      await this.templates.push(block)

      // Scroll to bottom popup content
      const popupContent = document.querySelector('.vs-popup--content')
      popupContent.scrollTop = popupContent.scrollHeight + 500
    },

    async saveTemplate (data) {
      if (data.new) {
        const response = await MessageTemplates.addOne(this.companySlug, this.scenarioSlug, this.stepId, data)
        if (response.status === 'success') {
          const templateIndex = this.templates.findIndex(template => data.id === template.id)
          this.templates.splice(templateIndex, 1)
          this.templates.push(response.data)
          this.$vs.notify({
            color: 'success',
            title: 'Успешно добавлено',
            text: ''
          })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'При добавлении произошла ошибка',
            text: ''
          })
        }
      } else {
        const response = await MessageTemplates.updateOne(this.companySlug, this.scenarioSlug, this.stepId, data.id, data)
        if (response.status === 'success') {
          const templateIndex = this.templates.findIndex(template => response.data.id === template.id)
          this.templates.splice(templateIndex, 1, response.data)
          this.$vs.notify({
            color: 'success',
            title: 'Успешно обновлено',
            text: ''
          })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'При обновлении произошла ошибка',
            text: ''
          })
        }
      }
    },

    deleteTemplate (data) {
      if (data.new) {
        const templateIndex = this.templates.findIndex(template => data.id === template.id)
        this.templates.splice(templateIndex, 1)
      } else {
        const deleteTemplate = async () => {
          const response = await MessageTemplates.deleteOne(this.companySlug, this.scenarioSlug, this.stepId, data.id)
          if (response.status === 'success') {
            const templateIndex = this.templates.findIndex(template => data.id === template.id)
            this.templates.splice(templateIndex, 1)
            this.$vs.notify({
              color: 'success',
              title: 'Успешно удалено',
              text: ''
            })
          }
        }
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Вы точно хотите удалить?',
          text: '',
          accept: deleteTemplate,
          acceptText: 'Удалить',
          cancelText: 'Отменить'
        })
      }
    },

    async changeOrder () {
      const messages = this.templates.map((template, index) => ({
        id: template.id,
        order: index
      }))

      const response = await MessageTemplates.sort(this.companySlug, this.scenarioSlug, this.stepId, {
        messages
      })

      if (response.status === 'success') {
        this.templates = response.data
        this.$vs.notify({
          color: 'success',
          title: 'Успешно отсортировано',
          text: ''
        })
      } else {
        this.$vs.notify({
          color: 'success',
          title: 'Ошибка при сортировке',
          text: ''
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .content-blocks {
    border-top: 1px solid #e5e5e5;
  }
  .buttons-in-popup{
    position: sticky;
    z-index: 1000;
    bottom: 0;
    padding: 1.5rem;
    border-top: 1px solid #e5e5e5;
    border-radius: 0 0 10px 10px;
    background: #fff;
  }
  .icon-draggable {
    width: 44px;
    height: 44px;
    padding: 12px;
    font-size: 1.25rem;
    transition: .2s ease-in-out;
    color: #d5d5d5;
  }
  .templates-list {
    &__item {
      padding: 15px 0;
      cursor: move;
      &:hover {
        .icon-draggable {
          color: #8f8f8f;
        }
      }
    }
    &--disabled {
      .icon-draggable {
        opacity: 0;
      }
      .templates-list__item {
        cursor: default;
      }
    }
  }
</style>
